export default __webpack_public_path__ + "static/media/logo-flip.420c0bf1.png";